import { Tooltip } from '@/components/Atoms/Tooltip/Tooltip';
import { useSelectReportFileIds } from '@/features/NeedlReport/hooks/useReport';
import SuggestedQuestionIcon from '@/icons/suggested_questions.svg?react';

export const FollowupQuestions = ({
  questions,
  disabled = false,
  handleAskQuestion,
}: FollowupQuestionsType) => {
  const { selectedIds } = useSelectReportFileIds();
  return (
    <div className='flex flex-col gap-1 mt-4'>
      <div className='flex gap-2 text-gray-700'>
        <div className='w-5 h-5'>
          <SuggestedQuestionIcon />
        </div>
        <div className='font-medium text-sm mt-px'>Suggested Questions</div>
      </div>
      <div className='divide-y divide-gray-300'>
        {questions.map((question) => (
          <Tooltip
            key={question}
            label={selectedIds?.length === 0 ? 'Select a source first.' : ''}
          >
            <button
              disabled={disabled || selectedIds?.length === 0}
              onClick={() => {
                if (handleAskQuestion) {
                  handleAskQuestion(question);
                }
              }}
              className='w-full hover:text-emerald-900 text-gray-700 transition-colors text-left text-sm py-2 pl-1 disabled:cursor-not-allowed disabled:text-gray-500'
            >
              {question}
            </button>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

type FollowupQuestionsType = {
  questions: string[];
  handleAskQuestion?: (question: string) => void;
  disabled?: boolean;
};
